import React, { useCallback, useEffect, useState } from 'react';

import { LEADS_PAGE_TITLE, LEADS_PAGE_DESCRIPTION } from 'constants/leads';
import { ConstraintVariants } from 'constants/shared';
import useModal from 'hooks/use-modal/useModal';
import { usePaginationWithSearch } from 'hooks/use-pagination-with-search/usePaginationWithSearch';
import useTableSorting from 'hooks/use-table-sorting/useTableSorting';
import { getLeads } from 'modules/leads/action';
import { selectIsLoading, selectLeads, selectLeadsPaginationData } from 'modules/leads/selectors';
import { useAppDispatch, useAppSelector } from 'modules/store';
import { DashboardLayout, LeadsTable } from 'page-components';
import LeadMoreInfoModal from 'page-components/leads/LeadMoreInfoModal';
import { Constraint, Pagination, SearchForm, TitleWithDescription } from 'shared-components';

const LEADS_PER_PAGE = 8;

const Leads = () => {
  const dispatch = useAppDispatch();

  const isLoading = useAppSelector(selectIsLoading);
  const leads = useAppSelector(selectLeads);
  const leadsPaginationData = useAppSelector(selectLeadsPaginationData);
  const [filteredParams, setFilteredParams] = useState('');

  const { page, setPage, query, handleFilter } = usePaginationWithSearch();
  const { sorting, updateSorting } = useTableSorting();
  const { onOpen, ...modalState } = useModal();
  const [currentName, setcurrentName] = useState<string>('');
  const [reasonForInterest, setReasonForInterest] = useState<string>('');

  const handleOpenModal = (name: string, reason: string) => {
    setcurrentName(name);
    setReasonForInterest(reason);
    onOpen();
  };

  const loadUsers = useCallback(() => {
    dispatch(
      getLeads({
        page,
        per_page: LEADS_PER_PAGE,
        sort: sorting.column,
        order: sorting.order,
        query,
        filter: filteredParams,
      }),
    );
  }, [filteredParams, dispatch, page, sorting.column, sorting.order, query]);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  return (
    <DashboardLayout>
      <Constraint variant={ConstraintVariants.FULL_ROUNDED}>
        <TitleWithDescription
          descriptionClassName='pt-2'
          title={LEADS_PAGE_TITLE}
          description={LEADS_PAGE_DESCRIPTION}
        />
        <div className='flex items-start sm:items-end flex-col sm:flex-row gap-4 sm:gap-0 mb-6'>
          <SearchForm
            handleFilter={handleFilter}
            placeholder='Search by Name'
            className='flex-col sm:flex-row gap-4 sm:gap-0 w-full sm:w-auto'
          />
        </div>

        <LeadsTable
          loading={isLoading}
          updateSorting={updateSorting}
          rowsNumber={LEADS_PER_PAGE}
          leads={leads}
          handleOpenModal={(name: string, reason: string) => handleOpenModal(name, reason)}
        />

        <LeadMoreInfoModal {...modalState} name={currentName} info={reasonForInterest} />

        <Pagination loading={isLoading} currentPage={page} updatePage={setPage} {...leadsPaginationData} />
      </Constraint>
    </DashboardLayout>
  );
};
export default Leads;
